/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import Theme from "./theme";
import Constants from "app_constants";

const Footer = (props) => {
  return (
    <Theme>
      <div className="footer appFooter">
        <div className="content has-text-centered">
          <p className="footerTxt">
            <strong>Remote Jobs</strong> platform is created with{" "}
            <span className="heartIcon">♥</span> by{" "}
            <a
              className="brand"
              href="https://www.onurdemirtas.com"
              target="_blank"
            >
              Onur Demirtaş
            </a>
          </p>

          <p className="adress">{Constants.address}</p>

          <a
            href="https://www.linkedin.com/company/remotejobsio"
            target="_blank"
          >
            <i className="fab fa-linkedin socialIcons"></i>
          </a>

          <a href="https://www.facebook.com/remotejobsio" target="_blank">
            <i className="fab fa-facebook-f socialIcons"></i>
          </a>

          <a href="https://www.instagram.com/remotejobsio" target="_blank">
            <i className="fab fa-instagram socialIcons"></i>
          </a>

          <a href="https://twitter.com/remotejobs_" target="_blank">
            <i className="fab fa-twitter socialIcons"></i>
          </a>

          <a
            href="https://www.youtube.com/channel/UC930rc0at5dnJcfYAvJYcuw"
            target="_blank"
          >
            <i className="fab fa-youtube socialIcons"></i>
          </a>
        </div>
      </div>
    </Theme>
  );
};

export default Footer;
